<template>
  <van-swipe class="guide" v-if="opened" :loop="false" @change="change">
    <van-swipe-item v-for="(img, index) in list" :key="index">
      <div class="img-wrap">
        <img
          class="img"
          ondragstart="return false;"
          :src="img"
          alt=""
          @click="clickSwipeItem(index)"
        />
      </div>
    </van-swipe-item>

    <!-- 最后一张空白页，为了实现最后一页滑动关闭能力 -->
    <van-swipe-item></van-swipe-item>
  </van-swipe>
</template>

<script>
export default {
  data() {
    return {
      // 新手引导的版本
      version: "1.16",
      // 是否展示
      opened: false,
      list: [
        "https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/guide/1.16/01.png",
        "https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/guide/1.16/02.png",
        "https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/guide/1.16/03.png",
        "https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/guide/1.16/04.png",
        "https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/guide/1.16/05.png",
      ],
    };
  },
  methods: {
    // 新手引导相关
    setGuideFlag() {
      app.ls.set("x3-teacher-guide", {
        version: this.version,
      });
    },
    // 是否需要展示新手引导
    guide() {
      let obj = app.ls.get("x3-teacher-guide");
      if (!obj || obj.version != this.version) {
        // 之所以加下面的判断，是为了新用户注册机构时，等他完成注册后，再展示。不要影响他注册机构的流程
        if (app.teacher.campusId) {
          this.opened = true;
        }
      }

      return new Promise((resolve) => {
        this._resolve = resolve;
      });
    },
    open() {
      this.opened = true;
    },
    close() {
      this.setGuideFlag();
      this.opened = false;
    },
    change(index) {
      if (index == this.list.length) {
        this.close();
      }
    },
    clickSwipeItem(index) {
      if (index == this.list.length - 1) {
        this.close();
      }
    },
  },
  created() {
    // 提供给测试人员做自动化测试，去除新手引导的方法
    app.teacher.test_guide = {
      close: this.close,
    };
  },
};
</script>

<style lang="scss" scoped>
.guide {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9;
  .van-swipe-item {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    background: #ffffff;
    .img-wrap {
      width: 90%;
      height: 90%;
      .img {
        max-height: 100%;
        max-width: 100%;
      }
    }
    .close-btn {
      position: absolute;
      width: 100px;
      height: 100px;
      background: #f00;
      margin-top: -100px;
    }
  }
}
</style>
